export default "__VITE_PUBLIC_ASSET__65b024e5__"